export default "__VITE_ASSET__8bc70252__"